module.exports = __webpack_public_path__ + "static/sugro-370545d24e987a206ec553821717721b.png";